if (Cookies.get('age_gate') != 'yes') {
  document.querySelector('#age-gate').classList.toggle('show');
  document.querySelector('.body').classList.toggle('age-gate');
} else {
  $(document).ready(function () {
    if (Cookies.get('cp_signup') != 'yes') {
      setTimeout(function () {
        document.querySelector('#signup-popup').classList.toggle('show');
      }, document.querySelector('#signup-popup').getAttribute("data-delay"));
    }
  });
}

if (Cookies.get('cp_signup') == 'yes') {
  document.querySelector('#signup-popup').remove();
}

function dismissAgeGate() {
  document.querySelector('#age-gate').classList.toggle('hidden');
  document.querySelector('#age-gate').classList.toggle('show');
  document.querySelector('.body').classList.toggle('age-gate');

  if (Cookies.get('cp_signup') != 'yes') {
    setTimeout(function () {
      document.querySelector('#signup-popup').classList.toggle('show');
    }, document.querySelector('#signup-popup').getAttribute("data-delay"));
  }
}

$(document).ready(function () {
  $("#age-gate .accept").click(function (event) {
    Cookies.set('age_gate', 'yes', {
      expires: 7
    })

    var ageGate = document.querySelector('#age-gate');
    var playIntro = window.matchMedia('(min-width: 1024px)').matches;

    if (playIntro) {
      ageGate.classList.add('play-intro');
      // Intro sequence ends when introWrapper finishes (4.5s delay + 1s duration)
      setTimeout(dismissAgeGate, 5500);
    } else {
      dismissAgeGate();
    }
  });
});
